import { reviveIntegersAsBigInt } from "./reviveIntegersAsBigInt";

/**
 * `JSON.parse` reviver for a value count (`GET v1/query/id/{id}/value-counts`):
 * reads as a `bigint` each integer that can run past
 * `Number.MAX_SAFE_INTEGER`, which are a counted `value`, such as a session's
 * nanosecond `min_timestamp_ns`, and the nanosecond `first_time` and
 * `last_time` of the records holding it.
 */
export const parseValueCountIntegersAsBigInt = reviveIntegersAsBigInt([
  "value",
  "first_time",
  "last_time",
]);
